import { render } from "./plannerGroups.vue?vue&type=template&id=222c0e9e&scoped=true"
import script from "./plannerGroups.vue?vue&type=script&lang=js"
export * from "./plannerGroups.vue?vue&type=script&lang=js"

import "./plannerGroups.vue?vue&type=style&index=0&id=222c0e9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222c0e9e"]])

export default __exports__